import errorIcon from "../../assets/icons/cross.svg";
import documentIcon from "../../assets/icons/pages.svg";
import { useTranslation } from "react-i18next";
import "./EmptyState.css";

const EmptyState = ({ error = null }) => {
  const { t } = useTranslation();

  return (
    <div className="empty-state-container">
      <div className="empty-state-content">
        <img
          className="empty-state-icon"
          src={error ? errorIcon : documentIcon}
          alt={error ? t("emptyState.errorAlt") : t("emptyState.documentAlt")}
        />

        <h1 className="empty-state-title">
          {error ? t("emptyState.unableToLoad") : t("emptyState.noDocument")}
        </h1>

        <p className="empty-state-description">
          {error ? error : t("emptyState.requestDoc")}
        </p>
      </div>
    </div>
  );
};

export default EmptyState;
